<h2 mat-dialog-title>{{ data.title }} — Comment</h2>

<mat-dialog-content>
  <mat-form-field appearance="fill" class="w-full">
    <textarea
      matInput
      [(ngModel)]="data.comment"
      placeholder="Type your comment..."
      rows="4"
    ></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!data.comment.trim()">
    Save
  </button>
</mat-dialog-actions>
